import cn from 'classnames';
import PropTypes from 'prop-types';
import { InfoTitle } from '../../common/InfoTooltip';
import { InfoIcon } from '../../icons/InfoIcon';
import styles from './AnalyticsToggler.module.scss';

export const TOGGLER_STYLES = {
  Large: styles.analyticsTogglerWrapper,
  Thin: styles.analyticsTogglerWrapperThin,
};

export function AnalyticsToggler({ selected, onChange, options, style = TOGGLER_STYLES.Large }) {
  return (
    <div className={style}>
      {options.map((option) => (
        <button
          key={option.value}
          className={cn(styles.option, option.value === selected ? styles.selected : '')}
          onClick={() => onChange(option.value)}
        >
          {option.label}
          {option.tooltipContent && (
            <InfoTitle content={option.tooltipContent} disabled={!option.tooltipContent}>
              <div className={styles.infoIconWrapper}>
                <InfoIcon
                  color={option.value === selected ? styles.selectedInfoIconColor : styles.unselectedInfoIconColor}
                />
              </div>
            </InfoTitle>
          )}
        </button>
      ))}
    </div>
  );
}

AnalyticsToggler.propTypes = {
  selected: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  style: PropTypes.oneOf(Object.values(TOGGLER_STYLES)),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.string.isRequired,
      tooltipContent: PropTypes.string,
    }),
  ).isRequired,
};
